<template>
  <div class="md:flex -mx-8">
    <div class="md:w-1/2 mx-8">
      <div class="mb-6">
        <h3 class="font-semibold py-3">Eigen velden</h3>
        <CustomfieldList :customfields="customfields" />
      </div>
      <ModalButton class="btn btn-blue" label="Eigen veld toevoegen" size="max-w-xl">
        <CustomfieldForm action="/json/customfields" />
      </ModalButton>
    </div>
    <div class="hidden md:block w-1/2 mx-8">
      <SettingsTip>De gegevens die je bij een dossier (organisatie of particulier) opslaat kun je uitbreiden met zelf toegevoegde velden.</SettingsTip>
    </div>
  </div>
</template>

<script>
import SettingsTip from "@/components/SettingsTip";
import CustomfieldList from "@/components/CustomfieldList";
import CustomfieldForm from "@/components/CustomfieldForm";

export default {
  components: {
    SettingsTip,
    CustomfieldList,
    CustomfieldForm
  },

  computed: {
    customfields() {
      return this.$store.state.settings.customfields;
    }
  }
};
</script>
